export default {
  oneQuarter: {
    width: '20%'
  },
  threeQuarters: {
    width: '70%',
    marginRight: '5%'
  },
  fullWidth: {
    width: '100%'
  },
  autoComplete: {
    marginTop: 40,
    height: 'unset'
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};



// WEBPACK FOOTER //
// ./src/styles/form.js